import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

export class PriceBoostComboPrevention extends BaseComboPrevention<BetslipPick, BetslipPick> {
    constructor() {
        super(BetslipPick, BetslipPick);
    }

    validate(thisPick: BetslipPick): ComboPreventionResult {
        if (thisPick.boostedPriceDetails?.isPriceBoosted) {
            // Can not combine sport with Forecast or tricast races.
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}
